'use client'

import { useContext } from 'react'
import { Cell, Spacer, Text, Icon } from '@vinted/web-ui'
import { ElectronicsBadgeFilled16 } from '@vinted/monochrome-icons'

import { EscrowFeesContext } from '@marketplace-web/escrow-pricing/escrow-pricing-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const ItemPageElectronicsVerificationStatusPlugin = () => {
  const translate = useTranslate('item.status')
  const { escrowFees } = useContext(EscrowFeesContext)
  if (!escrowFees?.electronicsVerification) return null

  return (
    <div className="electronics-verification-status">
      <Cell
        styling="narrow"
        theme="transparent"
        testId="electronics-verification-service-block-status"
      >
        <div className="u-flexbox u-align-items-center">
          <Spacer orientation="vertical" />
          <Icon
            name={ElectronicsBadgeFilled16}
            color="primary-default"
            aria={{
              'aria-hidden': 'true',
            }}
          />
          <Spacer orientation="vertical" />
          <Text
            as="h4"
            text={translate('electronics_verification')}
            type="caption"
            theme="amplified"
          />
        </div>
      </Cell>
    </div>
  )
}

export default ItemPageElectronicsVerificationStatusPlugin
